import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_API_URL } from "../../../../utils/consts";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button, Col, Divider, Row, Select, Space, Tag } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  WarningOutlined,
} from "@ant-design/icons";

import { ReactComponent as OvertimeIcon } from "../../../../assets/images/icons/overtime.svg";
import {
  addYears,
  differenceInDays,
  eachDayOfInterval,
  endOfYear,
  format,
  isWeekend,
  parseISO,
  startOfYear,
  subYears,
} from "date-fns";
import { isAdmin } from "../../../../utils/permissions";
import { useAuth } from "../../../../utils/useAuth";
import UserOvertimeModal from "../../../../Components/Modals/UserOvertimeModal/UserOvertimeModal";
const { Option } = Select;

type Props = { userDetails: any };

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}

enum CountingOption {
  TOTAL_DAYS,
  WEEKDAYS_ONLY,
  WEEKDAYS_AND_SATURDAY_ONLY,
}

const UserOvertimes: React.FC<Props> = ({ userDetails }) => {
  const { t } = useTranslation();
  const params = useParams();
  const authUser: any = useAuth();
  const [overtimes, setOvertimes] = useState<any>(undefined);
  const [leaveModalOpen, setLeaveModalOpen] = useState<any>(false);
  const [activeYear, setActiveYear] = useState<any>(format(new Date(), "yyyy"));
  const [counts, setCounts] = useState<{ [key: string]: number }>({});
  useEffect(() => {
    axios
      .get(
        `${BASE_API_URL}/${params.id}/user_details_overtimes?year=${activeYear}`,
        {
          params: {
            // userId: params.id,
          },
        }
      )
      .then((res) => {
        setOvertimes(res.data);
      })
      .catch((error) => console.error(error));
  }, [params.id, activeYear]);

  const onSelectYear = (params: any) => {
    setActiveYear(params);
  };

  const getLeaveType = (type: any) => {
    const findLeaveType = userDetails?.user?.clientLeaves?.find(
      (item: any) => item.leaveName === type
    );
    return findLeaveType;
  };

  const columns: ColumnsType<DataType> = [
    {
      title: t("Start Time"),
      dataIndex: "from",
      key: "from",
      render: (value, row) => {
        return format(new Date(value), "HH:mm");
      },
    },
    {
      title: t("End Time"),
      dataIndex: "to",
      key: "to",
      render: (value, row) => {
        return format(new Date(value), "HH:mm");
      },
    },
    // {
    //   title: t("Total Days"),
    //   dataIndex: "totalDays",
    //   key: "totalDays",
    //   render: (value, row: any) => {
    //     return "4";
    //   },
    // },
    // {
    //   title: t("Leave Type"),
    //   dataIndex: "clientLeaveId",
    //   key: "clientLeaveId",
    //   render: (value, row: any) => {
    //     return `${row?.clientLeaveId?.leaveName ?? ""}`;
    //   },
    // },
    {
      title: "",
      dataIndex: "warning",
      key: "warning",
      render: (value, row: any) => {
        return counts[row?.clientLeaveId?.leaveName] + getTotalDays(row) >
          row?.clientLeaveId?.totalDays && row.isApproved !== "REJECTED" ? (
          <div className="warningLeave">
            <WarningOutlined />
          </div>
        ) : (
          ""
        );
      },
    },
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      render: (value, status) => {
        const color =
          value === "APPROVED"
            ? "green"
            : value === "PENDING"
            ? "orange"
            : "red";
        return (
          <>
            <Tag color={color} key={value}>
              {t(value)}
            </Tag>
          </>
        );
      },
    },

    {
      title: "",
      key: "action",
      render: (row, record: any) => (
        <>
          <Space size="middle">
            {isAdmin(authUser?.roles) && (
              <>
                <Button onClick={() => onUpdateLeave("APPROVED", record._id)}>
                  <CheckOutlined />
                </Button>
                <Button onClick={() => onUpdateLeave("REJECTED", record._id)}>
                  <CloseOutlined />
                </Button>
              </>
            )}
            <Button onClick={() => onDeleteLeave(record._id)}>
              <DeleteOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const onUpdateLeave = (status: any, overtimeId: any) => {
    axios
      .put(`${BASE_API_URL}/${overtimeId}/overtime_update`, {
        status: status,
      })
      .then((res) => {
        axios
          .get(
            `${BASE_API_URL}/${params.id}/user_details_overtimes?year=${activeYear}`
          )
          .then((res) => {
            setOvertimes(res.data);
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  };

  const onDeleteLeave = (overtimeId: any) => {
    axios
      .delete(`${BASE_API_URL}/overtime/${overtimeId}/delete`)
      .then((res) => {
        axios
          .get(
            `${BASE_API_URL}/${params.id}/user_details_overtimes?year=${activeYear}`
          )
          .then((res) => {
            setOvertimes(res.data);
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  };

  const getTotalDays = (row: any) => {
    // if (leaveDateType === CountingOption.WEEKDAYS_ONLY) {
    //   return getTotalWeekdaysBetweenDates(row.to, row.from);
    // } else if (leaveDateType === CountingOption.WEEKDAYS_AND_SATURDAY_ONLY) {
    //   return getWeekdaysAndSaturdayCountBetweenDates(row.to, row.from);
    // } else {
    //   return differenceInDays(row.to, row.from);
    // }
    return 4;
  };

  const onAddOvertime = (overtime: any) => {
    axios
      .post(`${BASE_API_URL}/overtime/create`, {
        description: overtime.description,
        overtimeTypeId: overtime.clientOvertimeType,
        from: overtime.from,
        to: overtime.to,
        userId: userDetails?.user?._id,
        clientId: userDetails?.user?.clientId?._id,
        status: "PENDING",
      })
      .then((res) => {
        axios
          .get(
            `${BASE_API_URL}/${params.id}/user_details_overtimes?&year=${activeYear}`
          )
          .then((res) => {
            setOvertimes(res.data);
          });
        setLeaveModalOpen(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Calculation -----------------------------------------

  type Overtime = {
    overtimeTypeId: string;
    duration: number; // u minutima
    status: string;
    overtimeName: string;
  };

  type GroupedOvertime = {
    totalMinutes: number;
    formatted: string;
    overtimeName: string;
  };

  function groupByOvertimeName(
    overtimes: Overtime[]
  ): Record<string, GroupedOvertime> {
    const approved = overtimes?.filter((o) => o.status === "APPROVED");

    const grouped: Record<string, GroupedOvertime> = {};

    approved?.forEach((o) => {
      const key = o.overtimeName;

      if (!grouped[key]) {
        grouped[key] = {
          totalMinutes: 0,
          formatted: "",
          overtimeName: key,
        };
      }

      grouped[key].totalMinutes += o.duration;
    });

    Object.values(grouped).forEach((val) => {
      const hours = Math.floor(val.totalMinutes / 60);
      const minutes = val.totalMinutes % 60;
      val.formatted = `${hours}h ${minutes}min`;
    });

    return grouped;
  }

  // -----------------------------------------------------
  return (
    <>
      <Row justify="space-between">
        <Col>
          <Button onClick={() => setLeaveModalOpen(true)}>
            {t("Request Overtime")}
          </Button>
        </Col>
        <Col>
          <Select
            placeholder={t("Select year")}
            value={activeYear}
            onChange={onSelectYear}
          >
            <Option value={format(subYears(new Date(), 1), "yyyy")} key={`3`}>
              {format(subYears(new Date(), 1), "yyyy")}
            </Option>
            <Option value={format(new Date(), "yyyy")} key={"2"}>
              {format(new Date(), "yyyy")}
            </Option>
            <Option value={format(addYears(new Date(), 1), "yyyy")} key={`1`}>
              {format(addYears(new Date(), 1), "yyyy")}
            </Option>
          </Select>
        </Col>
      </Row>
      <Divider />
      <Row className="totalDaysContainer">
        {overtimes &&
          Object.entries(groupByOvertimeName(overtimes)).map(
            ([formatted, item]: any) => {
              return (
                <Col key={item.formatted}>
                  <div className="days">
                    <OvertimeIcon /> {item.overtimeName}
                    <span>{}</span>
                  </div>
                  <i>{item.formatted}</i>
                </Col>
              );
            }
          )}
      </Row>

      <Table columns={columns} dataSource={overtimes} />
      <UserOvertimeModal
        isOpen={leaveModalOpen}
        userDetails={userDetails}
        onCloseModal={() => setLeaveModalOpen(false)}
        onAddOvertime={onAddOvertime}
      />
    </>
  );
};

export default UserOvertimes;
